import {RemoteConfigNames} from 'config/remoteConfigNames';

const loadFromEnvWithDefault = (propName: string, defaultValue: string | boolean): string => {
  const defaultStringValue = typeof defaultValue === 'string' ? defaultValue : defaultValue ? 'true' : 'false';
  return process.env[propName] ? process.env[propName]! : defaultStringValue;
};

type ProductionConfigType = Record<keyof typeof RemoteConfigNames, string | boolean>;

const productionConfigDefaults: ProductionConfigType = {
  AddVehicle: true,
  AnnuityInterestRates: false,
  AutoGlassVendorFNOL: true,
  BillingOutageWindowStart: 'January 1, 2022',
  BillingOutageWindowEnd: 'January 1, 2022',
  BillingLifeOutageWindowStart: 'March 28, 2025 23:30',
  BillingLifeOutageWindowEnd: 'March 30, 2025 8:00',
  CEAPolicyInfo: false,
  EditAutoCoverages: true,
  EditDriversLicense: true,
  EditHomeCoverages: true,
  EditLifeAddress: true,
  EstimateDriverStates:
    'AK,AL,AR,AZ,CA,CO,CT,DC,DE,FL,GA,IA,ID,IL,IN,KS,KY,LA,MA,MD,ME,MI,MN,MO,MS,MT,NC,ND,NE,NH,NJ,NM,NV,OH,OK,OR,PA,RI,SC,SD,TN,TX,UT,VA,VT,WI,WA,WV,WY',
  EstimateVehicle: true,
  FNOLTextNotification: true,
  LifeABSBanner: true,
  LifeQuotingApplicationOutageStart: 'January 1, 2025',
  LifeQuotingApplicationOutageEnd: 'January 1, 2025',
  RemoveLender: true,
  RemoveVehicle: true,
  RemoveVehicleReasonLoggingAPI: true,
  AppleWallet: true,
  EnableQuotingCrossSellBanner: true,
  EnableQuotingBindOnline: true,
  EnableQuotingBindOnlineDwelling: 'HO4',
  EnableEASQuotingBindOnline: true,
  EnableEASQuotingBindOnlineDwelling: '',
  EnableSmarterHomeDiscountPromo: 'ME,MA,TX,IA,IN,UT',
  RemoveLenderMaximumLendersAllowed: '1',
  TempRemoveWelcomeBannerMobileApp: false,
  DisableExpressID: false,
  EnabledTextingNotificationPreferences: 'Mutual_Claims,Mutual_Policy_Billing,Mutual_Policy',
  TempEnableAdobeTargetVECIntegration: false,
  TempBillingChangePaymentPlan: true,
  TempEnableChangePaymentPlanWithSemiAnnualDiscount: false,
  EnableHeadingDebugging: false,
  AutopayDiscountStates: 'PA, NH, TX, RI, CO, CT, VA',
  CalendlyRolloutStates: 'AZ,MA,NY',
  CalendlyBannerStates: 'RI,VT,NH,ME',
  TempEnableLifeQuoting: true,
  EnableBoardOfDirectorsLink: false,
  TempEnableOnboarding: false
};

type RemoteConfigType = typeof RemoteConfigNames;

export const RemoteConfigDefaults = Object.keys(productionConfigDefaults).reduce<RemoteConfigType>(
  (runningConfig, key: keyof RemoteConfigType) => ({
    [key]: loadFromEnvWithDefault(RemoteConfigNames[key], productionConfigDefaults[key]),
    ...runningConfig
  }),
  {} as RemoteConfigType
);
